import { render, staticRenderFns } from "./PaginationTop.vue?vue&type=template&id=1bf1bf32&lang=pug&"
import script from "./PaginationTop.vue?vue&type=script&lang=js&"
export * from "./PaginationTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports